import axios from 'axios';
import { API_URL } from '../../store/api/api.const';

export const validateAddress = async (value: string) => {
  try {
    const res = await axios.post(`${API_URL}/address/check/`, {
      address: value,
    });
    return res.data;
  } catch (error) {
    console.log(error);
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data;
    }
  }
};

export const validateEmail = async (email: string): Promise<{ error?: string }> => {
  try {
    await axios.post(`${API_URL}/account/validate/`, { email });
    return {};
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      return { error: error.response.data?.error || 'Invalid email address.' };
    }
    throw error;
  }
};

export const suggestionAddress = async (value: string) => {
  try {
    const res = await axios.post(`${API_URL}/address/suggestions/`, {
      address: value,
    });
    return res.data;
  } catch (error) {
    console.error(error);
    alert('Something went wrong. Please try again later');
    return false;
  }
};
